export default __webpack_public_path__ + "static/media/logoSimple.714574d0.png";